/*
 * Footer join: the last visible block on a page should touch the footer.
 * The theme gives every section a bottom margin. This removes it from the last
 * section that has any height, and from empty sections after it (their margins
 * would otherwise merge into one gap above the footer). Empty app sections are
 * also hidden in CSS.
 */
(function () {
  var MARK = 'section--last-join';

  var SKIP = { SCRIPT: 1, STYLE: 1, TEMPLATE: 1, LINK: 1, NOSCRIPT: 1 };

  function lastBox(el) {
    for (var i = el.children.length - 1; i >= 0; i--) {
      var c = el.children[i];
      if (!SKIP[c.tagName] && getComputedStyle(c).display !== 'none') return c;
    }
    return null;
  }

  // Walk down the last element at each level; any section on that path sits at the
  // bottom of the page, so its bottom margin goes.
  function zero(wrapper) {
    var el = wrapper;
    while (el) {
      if (el.classList.contains('section')) {
        el.classList.add(MARK);
        el.style.setProperty('margin-bottom', '0', 'important');
      }
      el = lastBox(el);
    }
  }

  function join() {
    var main = document.getElementById('main');
    if (!main) return;
    Array.prototype.forEach.call(main.querySelectorAll('.' + MARK), function (s) {
      s.classList.remove(MARK);
      s.style.removeProperty('margin-bottom');
    });
    for (var i = main.children.length - 1; i >= 0; i--) {
      var el = main.children[i];
      if (!el.classList.contains('shopify-section')) continue;
      zero(el);
      if (el.offsetHeight > 0) break;
    }
  }

  function run() {
    join();
    // Content such as recommendations and review widgets arrives after load.
    setTimeout(join, 1500);
    setTimeout(join, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', join);
  document.addEventListener('shopify:section:load', join);
  document.addEventListener('shopify:section:unload', join);
})();
